import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import cash from '@assets/icons/cash.png';

import PaymentImage from './PaymentImage';
import Subtitle from '../Subtitle';

import messages from './messages';

function OfflinePaymentMethods({ items }) {
  if (items.length === 0) return null;
  return (
    <>
      <FormattedMessage {...messages.cashPayment}>
        {label => <Subtitle>{label}</Subtitle>}
      </FormattedMessage>
      <FormattedMessage {...messages.cashPaymentName}>
        {paymentName => <PaymentImage aria-label={paymentName} src={cash} />}
      </FormattedMessage>
    </>
  );
}

OfflinePaymentMethods.propTypes = {
  items: PropTypes.array.isRequired,
};

export default OfflinePaymentMethods;
